import React, { useState } from "react";
import PropTypes from "prop-types";
import { HiOutlineFilter } from "react-icons/hi";
import ModalApp from "../../components/ModalApp";
import FilterContent from "./FilterContent";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import { categoryOrBrand } from "../../utils/categoryOrBrand";
import { useSelector, useDispatch } from "react-redux";
import {
  selectBrands,
  selectCategories,
  clearCheckBrand,
  clearCheckCategories,
} from "../../Redux/filterSlice";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ContainerFilter, FilterSidebar } from "./styles";

export default function FilterProducts({
  onClickCategory,
  onClickBrand,
  onClickApplyFilter,
  onClickClearFilter,
  target,
}) {
  const [show, setShow] = useState(false);
  const categories = useSelector(selectCategories);
  const brands = useSelector(selectBrands);
  const disp = useDispatch();
  const screenTracking = useScreenTracking();
  const getFilterType = categoryOrBrand(categories, brands);
  const isDesktop = useMediaQuery("(min-width:1024px)");

  const handleClose = () => {
    trackClick({
      title: "fechar-filtro",
      contentType: getFilterType,
      screenName: screenTracking,
      tagId: tagIdFromLegacySuffix("05"),
    });
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
    trackClick({
      title: "abrir-filtro",
      contentType: getFilterType,
      screenName: screenTracking,
      tagId: tagIdFromLegacySuffix("04"),
    });
  };

  const applyFilters = (close) => {
    trackClick({
      title: "filtrar",
      contentType: getFilterType,
      screenName: screenTracking,
      tagId: tagIdFromLegacySuffix("04"),
    });
    onClickApplyFilter();
    if (close) handleClose();
  };

  const clearFilters = (close) => {
    disp(clearCheckBrand());
    disp(clearCheckCategories());
    onClickClearFilter();
    if (close) handleClose();
  };

  if (isDesktop) {
    return (
      <FilterSidebar>
        <FilterContent
          variant="sidebar"
          target={target}
          onClickBrand={onClickBrand}
          onClickCategory={onClickCategory}
          onApply={() => applyFilters(false)}
          onClear={() => clearFilters(false)}
        />
      </FilterSidebar>
    );
  }

  return (
    <>
      <ContainerFilter className="d-flex justify-content-center">
        <button
          type="button"
          className="d-flex btn btn-outline-grey align-items-center"
          onClick={handleShow}
        >
          <HiOutlineFilter color="var(--primary-color)" size="1.1em" />
          <span className="ms-1 fs-6">Filtrar</span>
        </button>
      </ContainerFilter>
      <ModalApp show={show} handleModal={handleClose} contentClassName="modal-filter-responsive">
        <FilterContent
          variant="modal"
          target={target}
          onClickBrand={onClickBrand}
          onClickCategory={onClickCategory}
          onApply={() => applyFilters(true)}
          onClear={() => clearFilters(true)}
        />
      </ModalApp>
    </>
  );
}

FilterProducts.propTypes = {
  onClickCategory: PropTypes.func,
  onClickApplyFilter: PropTypes.func,
  onClickClearFilter: PropTypes.func,
  onClickBrand: PropTypes.func,
  target: PropTypes.string,
};
